import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { deleteFavorite } from './favoriteThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
const SLICE_NAME = 'favorite';

export const favoriteSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({
            builder,
            request: deleteFavorite,
            isDelete: true,
        });
    },
});

export const favorite = favoriteSlice.reducer;
